"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryTag = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/tag/tag");
const tag_utils_1 = require("@/components/common/tag/tag.utils");
let CategoryTag = class CategoryTag extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.tone = 'pink';
    }
    render() {
        return (0, tag_utils_1.renderTag)(this.tone, this.icon);
    }
};
__decorate([
    (0, decorators_js_1.property)({ type: String })
], CategoryTag.prototype, "tone", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], CategoryTag.prototype, "icon", void 0);
CategoryTag = __decorate([
    (0, decorators_js_1.customElement)('mm-category-tag')
], CategoryTag);
exports.CategoryTag = CategoryTag;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2F0ZWdvcnktdGFnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY2F0ZWdvcnktdGFnLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFnQztBQUNoQyxxREFBMkQ7QUFLM0QsdUNBQW9DO0FBQ3BDLGlFQUE2RDtBQUd0RCxJQUFNLFdBQVcsR0FBakIsTUFBTSxXQUFZLFNBQVEsZ0JBQVU7SUFBcEM7O1FBQ3VCLFNBQUksR0FBaUIsTUFBTSxDQUFBO0lBTXpELENBQUM7SUFIQyxNQUFNO1FBQ0osT0FBTyxJQUFBLHFCQUFTLEVBQUMsSUFBSSxDQUFDLElBQUksRUFBRSxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUE7SUFDeEMsQ0FBQztDQUNGLENBQUE7QUFONkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3lDQUE0QjtBQUMzQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7eUNBQWdCO0FBRmhDLFdBQVc7SUFEdkIsSUFBQSw2QkFBYSxFQUFDLGlCQUFpQixDQUFDO0dBQ3BCLFdBQVcsQ0FPdkI7QUFQWSxrQ0FBVyJ9